import { render, staticRenderFns } from "./DocumentosView.vue?vue&type=template&id=2c8d5690&scoped=true"
import script from "./DocumentosView.vue?vue&type=script&lang=js"
export * from "./DocumentosView.vue?vue&type=script&lang=js"
import style0 from "./DocumentosView.vue?vue&type=style&index=0&id=2c8d5690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d5690",
  null
  
)

export default component.exports